var $efe2b88f6e19d03a$exports = {};
$efe2b88f6e19d03a$exports = {
    "actions": `Eylemler`,
    "hideButtonLabel": `Daha az g\xf6ster`,
    "noTags": `Hi\xe7biri`,
    "showAllButtonLabel": (args, formatter)=>`T\xfcm\xfcn\xfc g\xf6ster (${formatter.number(args.tagCount)})`
};


export {$efe2b88f6e19d03a$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
